module.exports = __webpack_public_path__ + "img/mobileapplication4.6a1669fc.png";